import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { LoadingButton } from "@mui/lab";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { InputProfile, SelectProfile } from "../../../components/profile";
import WordpressCodeIntegration from "../wordpressCodeIntegration";

export const WordpressIntegrationForm = ({
  props,
  createLoading,
  platform,
  project,
  open,
  setOpen,
  integrationData = null,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full">
        <InputProfile
          formikProps={props}
          type="text"
          text={t("Website URL", "URL du site Web")}
          name="url"
          placeholder="Ex: https://mon-site-web.com"
        />
      </div>

      {project && project?.integration_data?.username && (
        <LoadingButton
          onClick={() => setOpen(true)}
          variant="contained"
          sx={{
            textTransform: "none",
            bgcolor: "#1a79cb",
            "&:hover": {
              bgcolor: "#5094cf",
            },
          }}
        >
          Changer l'intégration du plugin SEO
        </LoadingButton>
      )}

      <div className="w-full">
        <InputProfile
          formikProps={props}
          type="text"
          text={t("Username", "Nom d'utilisateur")}
          name="username"
          placeholder="Ex: BotBlogR"
        />
      </div>

      <div className="w-full">
        <InputProfile
          formikProps={props}
          type="text"
          text={t("Application password", "Mot de passe d'application")}
          name="password"
          placeholder="XXXX XXXX XXXX XXXX XXXX XXXX"
        />
      </div>

      {project && project?.integration_data?.username && (
        <div>
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            className="relative z-[999]"
          >
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-[999] w-screen overflow-y-auto bg-black/50">
              <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-4 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in max-sm:10/12 md:w-8/12 lg:w-6/12 sm:p-8 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <button
                    className="absolute top-2 right-3 text-gray-400 hover:text-gray-600 focus:outline-none text-2xl"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close</span>
                    &#10005;
                  </button>

                  <DialogTitle
                    as="h3"
                    className="text-xl font-semibold leading-6 text-gray-900"
                  >
                    {platform?.title}
                  </DialogTitle>

                  <a
                    href={platform?.tuto?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 text-sm hover:underline"
                  >
                    {platform?.tuto?.text}
                  </a>

                  <WordpressCodeIntegration
                    props={props}
                    createLoading={createLoading}
                  />
                </DialogPanel>
              </div>
            </div>
          </Dialog>
        </div>
      )}

      <LoadingButton
        type="submit"
        loading={createLoading || props.isSubmitting}
        variant="contained"
        sx={{
          textTransform: "none",
          bgcolor: "#8b5cf6",
          "&:hover": {
            bgcolor: "#7c3aed",
          },
        }}
      >
        {project ? platform?.updateBtnText : platform?.btnText}
      </LoadingButton>
    </div>
  );
};

export const WordpressSettingsForm = ({
  props,
  onlineDatas = null,
  isExport = false,
}) => {
  const { t } = useTranslation();

  const publish_states = [
    { name: "publish", label: "Publié" },
    { name: "pending", label: "En attente de relecture" },
    { name: "draft", label: "Brouillon" },
  ];

  useEffect(() => {
    if (!props.values["blog_url"] && onlineDatas) {
      props.setFieldValue("blog_url", onlineDatas["permalink"]);
    }
  }, [onlineDatas]);

  return (
    <div>
      <div className="flex flex-col gap-2 mb-4">
        <div className="">
          <div className="flex flex-col gap-4">
            <div className="w-full">
              <SelectProfile
                formikProps={props}
                options={publish_states}
                text={t("publish-states", "État de publication")}
                name="publish_status"
                required={true}
              />
            </div>
          </div>
        </div>

        {!isExport ?? (
          <div className="w-full">
            <InputProfile
              formikProps={props}
              type="text"
              text="Chemin d'URL du blog par défaut"
              name="blog_url"
              placeholder="Ex: https://botblogr.com/blog"
            />
          </div>
        )}
      </div>
    </div>
  );
};
